import { Box, Flex, Text, Icon } from "@chakra-ui/react"
import { useLocation, useNavigate } from "react-router-dom"
import { MdMyLocation } from "react-icons/md"
// import { AiOutlineCreditCard } from "react-icons/ai"
import { IoIosPeople } from "react-icons/io"
import { TbChartDotsFilled } from "react-icons/tb"
import { GiOrbital } from "react-icons/gi"
import { MdSatelliteAlt } from "react-icons/md"
import { FaEarthAmericas } from "react-icons/fa6"
import { TbLogout } from "react-icons/tb"
import { Admin } from "@/routes/paths"
import Auth from "@/utils/auth"
import React from "react"

interface MenuItem {
  title: string
  path: string
  icon: React.ElementType
}

interface SidebarProps {
  isMobileOpen: boolean
}

export const agentMenuItems: MenuItem[] = [
  {
    title: "Dashboard",
    path: Admin.DASHBOARD,
    icon: FaEarthAmericas,
  },
  {
    title: "User Management",
    path: Admin.MANAGEMENT,
    icon: IoIosPeople,
  },
  {
    title: "Satelite",
    path: Admin.SATELITE,
    icon: MdSatelliteAlt,
  },
  {
    title: "Satellite Events",
    path: Admin.EVENTS,
    icon: GiOrbital,
  },
  {
    title: "Location",
    path: Admin.LOCATION,
    icon: MdMyLocation,
  },
  {
    title: "Prediction",
    path: Admin.PREDICTION,
    icon: TbChartDotsFilled,
  },
]

const logoutItem = {
  title: "Logout",
  path: "/",
  icon: TbLogout,
}

const Sidebar: React.FC<SidebarProps> = ({ isMobileOpen }) => {
  const navigate = useNavigate()
  const location = useLocation()
  const headerHeight = "78px"
  const activeBg = "black"
  const inactiveBg = "transparent"
  const activeColor = "white"
  const inactiveColor = "black"

  return (
    <Box
      display={{ base: isMobileOpen ? "block" : "none", md: "block" }}
      position="fixed"
      top={headerHeight}
      left="0"
      h="calc(100vh - 78px)"
      w={{ base: "full", md: "250px" }}
      zIndex={10}
      bg={"whitesmoke"}
      p="4"
      transition="all 0.3s ease"
      boxShadow="xl"
    >
      <Flex direction="column" mt="3" h="full" pt="4">
        {agentMenuItems.map(({ title, icon, path }) => {
          const isActive = location.pathname === path

          return (
            <Box key={title}>
              <Box
                bg={isActive ? activeBg : inactiveBg}
                p="12px 20px"
                borderRadius="4px"
                mb="1"
                cursor="pointer"
                onClick={() => navigate(path)}
                _hover={{
                  bg: isActive ? activeBg : "brand.hover",
                }}
              >
                <Flex align="center">
                  <Icon
                    as={icon}
                    color={isActive ? activeColor : inactiveColor}
                    boxSize="6"
                    mr="4"
                  />
                  <Text
                    color={isActive ? activeColor : inactiveColor}
                    fontWeight={isActive ? "bold" : "normal"}
                    fontSize="sm"
                    pt="4"
                    display={{ base: "none", md: "block" }}
                  >
                    {title}
                  </Text>
                </Flex>
              </Box>
            </Box>
          )
        })}
        <Flex direction="column" mt="auto" pb="4">
          <Box
            bg={location.pathname === logoutItem.path ? activeBg : inactiveBg}
            p="12px 20px"
            borderRadius="4px"
            mb="1"
            cursor="pointer"
            onClick={() => {
              Auth.logOut()
            }}
            _hover={{
              bg: "brand.hover",
            }}
          >
            <Flex align="center">
              <Icon
                as={logoutItem.icon}
                color={
                  location.pathname === logoutItem.path
                    ? activeColor
                    : inactiveColor
                }
                boxSize="6"
                mr="4"
              />
              <Text
                color={
                  location.pathname === logoutItem.path
                    ? activeColor
                    : inactiveColor
                }
                fontWeight="bold"
                fontSize="sm"
                display={{ base: "none", md: "block" }}
              >
                {logoutItem.title}
              </Text>
            </Flex>
          </Box>
        </Flex>
      </Flex>
    </Box>
  )
}

export default Sidebar
